import { OrderDocumentsRequestApiParameter, retrieveOrderDocuments } from "@MasterBluePrint/Services/OrderDocumentsService";
import { OrderDocumentsRequestModel } from "@MasterBluePrint/Types/ApiModels";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<OrderDocumentsRequestApiParameter & HasOnError<any> & HasOnSuccess<OrderDocumentsRequestModel>, OrderDocumentsRequestModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};
export const RetrieveOrderDocuments: HandlerType = async props => {
    props.apiResult = await retrieveOrderDocuments(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain=[
    PopulateApiParameter,
    RetrieveOrderDocuments,
    ExecuteOnSuccessCallback,
];

const getOrderDocuments = createHandlerChainRunner(chain, "GetOrderDocuments");
export default getOrderDocuments;